import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Auth } from 'aws-amplify';
import { CacheService } from 'src/app/services/cache.service';
import { ConstantsService } from 'src/app/services/constants.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  public changePasswordForm: UntypedFormGroup;
  message: string = '';
  error: boolean;
  success = null;
  isProcessing: boolean = false;
  userName: any;
  nonEmailUser: boolean = false;
  provider: string;
  isSkeltonLoad = true;
  skeltonArray: any = [{}];

  screenHeight: number;
  screenWidth: number;
  windowWidth: string;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 658 && this.screenWidth < this.screenHeight) {
      this.windowWidth = `calc(${this.screenHeight}px - 100px )`;
    }
  }
  constructor(
    public constants: ConstantsService,
    private fb: UntypedFormBuilder,
    public userService: UserService,
  ) {
  }

  ngOnInit(): void {
    this.authcall();
    this.initialiseForm();
    this.onResize();
  }
  async authcall() {
    this.userService.getUser(true)
      .then(async data => {
        let { userName } = data;
        this.userName = userName;
        this.userName.includes('google') ? (this.provider = 'Google', this.nonEmailUser = true) : this.userName.includes('facebook') ? (this.provider = 'Facebook', this.nonEmailUser = true) : this.nonEmailUser = false;
        this.isSkeltonLoad = false;
      }).catch(err => {
        // console.log(err);
        this.isSkeltonLoad = false;
        this.success = false;
        setTimeout(() => {
          this.success = null;
        }, 5000);
      })
  }
  async changePassword() {
    if (this.changePasswordForm.invalid) return;
    let newpass;
    this.isProcessing = true;
    if (this.changePasswordForm.value.newpassword !== this.changePasswordForm.value.reenterpassword) {
      this.message = 'New password field and Re enter password field value should be same';
      this.isProcessing = false;
      this.error = true;
      return;
    } else {
      newpass = this.changePasswordForm.value.newpassword;
    }
    Auth.currentAuthenticatedUser()
      .then(user => {
        return Auth.changePassword(user, this.changePasswordForm.value.oldpassword, newpass);
      })
      .then(data => {
        this.success = true;
        setTimeout(() => {
          this.success = null;
        }, 5000);
        this.isProcessing = false;
        this.changePasswordForm.reset();
      })
      .catch(err => {
        this.success = false;
        this.error = true;
        setTimeout(() => {
          this.success = null;
          this.error = false;
        }, 5000);
        this.isProcessing = false;
        if (err.code === 'NotAuthorizedException' || err.code === 'InvalidParameterException') {
          this.message = 'Old Password is incorrect';
          this.isProcessing = false;
          return;
        }
        this.message = err.message;
      });
  }
  initialiseForm = () => {
    this.changePasswordForm = this.fb.group({
      oldpassword: new UntypedFormControl('', [Validators.required]),
      newpassword: new UntypedFormControl('', [Validators.required]),
      reenterpassword: new UntypedFormControl('', [Validators.required])
    })
  }
  onClickSowPassowrd() {
    let inputFiled = (<HTMLInputElement>document.getElementById('input-password'))
    if (inputFiled.type === 'password') {
      inputFiled.type = 'text'
    }
    else {
      inputFiled.type = 'password'
    }
  }
}
